// src/app/data/auth/AuthApi.ts
import { DataFetcher } from '@/app/data/api/DataFetcher';
import type { AuthResponse } from '@/app/data/ApiModels';

const AUTH_TOKENS_KEY = 'auth_tokens';

export class AuthApi {
  private fetcher = new DataFetcher();

  /** Первичная аутентификация через Telegram initData */
  async validate(initData: string): Promise<AuthResponse> {
    const data = await this.fetcher.post<AuthResponse>(
      '/client/auth/telegram/validate',
      { initData }
    );
    // Сохраняем токены
    AuthApi.saveTokens(data);
    return data;
  }

  /** Обновление access‑токена через refresh */
  async refreshToken(refreshToken: string): Promise<AuthResponse> {
    const data = await this.fetcher.post<AuthResponse>(
      '/client/auth/refresh',
      { refreshToken }
    );
    AuthApi.saveTokens(data);
    return data;
  }

  /** Сохраняет токены в localStorage (статический, чтобы можно было вызывать без экземпляра) */
  static saveTokens(tokens: {
    accessToken: string;
    refreshToken?: string;
    expiresAt?: string;
    refreshExpiresAt?: string;
  }): void {
    localStorage.setItem(AUTH_TOKENS_KEY, JSON.stringify(tokens));
  }

  /** Получить accessToken из хранилища */
  static getAccessToken(): string | null {
    try {
      const stored = localStorage.getItem(AUTH_TOKENS_KEY);
      return stored ? JSON.parse(stored).accessToken : null;
    } catch {
      return null;
    }
  }

  /** Получить refreshToken */
  static getRefreshToken(): string | null {
    try {
      const stored = localStorage.getItem(AUTH_TOKENS_KEY);
      return stored ? JSON.parse(stored).refreshToken : null;
    } catch {
      return null;
    }
  }

  /** Удалить все токены (логаут) */
  static clearTokens(): void {
    localStorage.removeItem(AUTH_TOKENS_KEY);
  }
}